const hexToBytes = (value: string) => {
  const pairs = value.match(/.{1,2}/g) ?? [];
  return Uint8Array.from(pairs.map((pair) => Number.parseInt(pair, 16)));
};

const bytesToBase64 = (value: ArrayBuffer) => {
  const bytes = new Uint8Array(value);
  let binary = '';
  bytes.forEach((byte) => { binary += String.fromCharCode(byte); });
  return window.btoa(binary);
};

/** Matches the existing AES-CBC password boundary without persisting plaintext. */
export const encryptCustomerPassword = async (password: string): Promise<string> => {
  const key = await window.crypto.subtle.importKey(
    'raw',
    hexToBytes(window.env.hashKey),
    { name: 'AES-CBC' },
    false,
    ['encrypt'],
  );
  const encrypted = await window.crypto.subtle.encrypt(
    { name: 'AES-CBC', iv: hexToBytes(window.env.iv) },
    key,
    new TextEncoder().encode(password),
  );
  return bytesToBase64(encrypted);
};
